import React from "react";
import styles from "./preloader.module.css"

export const Preloader = React.memo(() => {
    return (
        <div className={styles.wrapper__preload}>
            <svg
                className={styles.preload}
                width="101"
                height="101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M100.679 50.5292C100.679 78.1383 78.2914 100.523 50.667 100.527C23.0625 100.527 0.674957 78.1383 0.678957 50.5252C0.670956 22.9121 23.0585 0.527222 50.675 0.527222C78.2914 0.527222 100.679 22.9161 100.679 50.5292V50.5292Z"
                    fill="#3671E9"
                />
                <path
                    d="M70.3506 38.2808C69.7065 31.5845 63.9255 29.3404 56.6204 28.7004V19.408H50.9675V28.4523C49.4832 28.4523 47.963 28.4803 46.4548 28.5124V19.408H40.8019L40.7978 28.6924C39.5737 28.7164 38.3695 28.7404 37.1973 28.7404V28.7124L29.4 28.7084V34.7486C29.4 34.7486 33.5767 34.6686 33.5047 34.7446C35.797 34.7446 36.5412 36.0727 36.7572 37.2207V47.8052C36.9172 47.8052 37.1213 47.8132 37.3533 47.8452H36.7572L36.7532 62.6738C36.6532 63.3939 36.2291 64.5419 34.6289 64.5459C34.7009 64.6099 30.5202 64.5459 30.5202 64.5459L29.396 71.2982H36.7572C38.1254 71.2982 39.4736 71.3222 40.7938 71.3302L40.7978 80.7266H46.4468V71.4302C47.995 71.4622 49.4952 71.4742 50.9635 71.4742L50.9595 80.7266H56.6124V71.3502C66.1179 70.8062 72.779 68.4101 73.6031 59.4817C74.2712 52.2934 70.8907 49.0812 65.4938 47.7852C68.7783 46.1211 70.8306 43.181 70.3506 38.2808V38.2808ZM62.4373 58.3696C62.4373 65.3899 50.4154 64.5939 46.5788 64.5939V52.1414C50.4154 52.1494 62.4373 51.0493 62.4373 58.3696V58.3696ZM59.8049 40.8049C59.8049 47.1932 49.7713 46.4451 46.5788 46.4491V35.1606C49.7753 35.1606 59.8089 34.1446 59.8049 40.8049Z"
                    fill="white"
                />
                <path
                    d="M36.7708 47.5559H37.6109V48.1759H36.7708V47.5559Z"
                    fill="#0D0D2B"
                />
            </svg>
        </div>
    )
})